import './footer.css'

export const Footer = () => {

    return (
        <footer id="footer">
            <br />
            {/* <div className='row'>
                <div className='col-md-2' />
                <div className='col-md-8'>
                    <div className='row'>
                        <div className='col-md-4'>
                            <h5>Our Products</h5>
                            <ul className='menu'>
                                <li><a href='invoice'><label>Kellogg Garden Organics Soil</label></a></li>
                                <li><a href='invoice'><label>Kellogg Garden Organics Fertilizer</label></a></li>
                            </ul>
                        </div>
                        <div className='col-md-4'>
                            <h5>About Us</h5>
                            <ul className='menu'>
                                <li><a href='invoice'><label>Our Story</label></a></li>
                                <li><a href='invoice'><label>Responsibility</label></a></li>
                            </ul>
                        </div>
                        <div className='col-md-4'>
                            <h5>Support</h5>
                            <ul className='menu'>
                                <li><a href='invoice'><label>Open a Support Ticket</label></a></li>
                                <li><a href='invoice'><label>Training Manual</label></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div> */}
            <div className="row">
                <section className='copyright'>Copyright © {new Date().getFullYear()} Kellogg Garden Products</section>
            </div>
        </footer>
    );
};